import HttpCliente from "../servicios/HttpCliente";

export const saveInstitution = (institution) => {
  return HttpCliente.post("/institutions", institution);
};

export const getListInstitution = () => {
  return HttpCliente.getOnlyWithConfig("/institutions", { skipAuthRedirect: true });
};

export const deleteInstitution = (id) => {
  return HttpCliente.delete('/institutions/delete/' + id);
};

export const updateInstitution = (id, institution) => {
  return HttpCliente.put('/institutions/' + id, institution);
};
